// A badge cell: a tint badge by family, with an optional icon so the status never depends on color alone.

import React from 'react'
import PropTypes from 'prop-types'

export const BadgeCell = ({ badge }) =>
  badge ? (
    <span
      className={`me-badge-tint me-badge-tint-${badge.family}`}
      title={badge.detail || undefined}
    >
      {badge.icon && (
        <i
          className={`fa-regular fa-${badge.icon} me-badge-ico`}
          aria-hidden="true"
        />
      )}
      {badge.label}
    </span>
  ) : null

BadgeCell.propTypes = {
  badge: PropTypes.shape({
    label: PropTypes.string,
    family: PropTypes.string,
    detail: PropTypes.string,
    icon: PropTypes.string,
  }),
}
